import { CdoToAllDisMap } from '@onefootprint/core';
import type {
  ModernBusinessDecryptResponse,
  OnboardingRequirementCollectBusinessData,
} from '@onefootprint/request-types';
import { getAllAttributes } from './get-all-attributes';

/**
 * Gets the business vault fields that need to be decrypted based on the requirement's attributes.
 * This maps CDOs (Collected Data Options) to business vault field names.
 */
export const getBusinessVaultFields = (
  requirement: OnboardingRequirementCollectBusinessData,
): (keyof ModernBusinessDecryptResponse)[] => {
  const attributes = getAllAttributes(requirement);
  return attributes.flatMap(attr => CdoToAllDisMap[attr] ?? []) as (keyof ModernBusinessDecryptResponse)[];
};
